import React from 'react';
import cn from 'classnames';
import styles from './styles.css';
import { dollarMask } from '../../core/util';

const PercentComponent = ({
  percent,
  readOnly,
  onKeyDown,
  handleChange,
  isSummitIClassMinValid
}) => {
  return readOnly ? (
    <strong className="percent-icon">{percent}%</strong>
  ) : (
    <>
      <input
        className={`number-input${
          isSummitIClassMinValid ? ' iclass-invalid-amount' : ''
        }`}
        type="number"
        min="0"
        value={percent}
        step="1"
        onKeyDown={onKeyDown}
        onChange={handleChange}
      />
      <span className="percent-icon">%</span>
      <style jsx>{styles}</style>
    </>
  );
};

const DollarComponent = ({
  dollarValue,
  readOnly,
  onKeyDown,
  handleChange
}) => {
  return readOnly ? (
    <strong className="dollar-value">${dollarMask(dollarValue)}</strong>
  ) : (
    <>
      <span className="dollar-value">$</span>
      <input
        className="number-input"
        type="number"
        min="0"
        value={dollarValue}
        step="1"
        onKeyDown={onKeyDown}
        onChange={handleChange}
      />
      <style jsx>{styles}</style>
    </>
  );
};

const AllocationInput = ({
  percent,
  dollarValue,
  percentMode,
  onChange,
  readOnly,
  isSummitIClassMinValid
}) => {
  const onKeyDown = event => {
    if (['.', '-'].includes(event.key)) event.preventDefault();
  };

  const handleChange = ({ target: { value } }) => onChange(value);

  return (
    <div className={cn('allocation-input', { 'percent-mode': percentMode })}>
      {percentMode ? (
        <PercentComponent
          percent={percent}
          readOnly={readOnly}
          onKeyDown={onKeyDown}
          handleChange={handleChange}
          isSummitIClassMinValid={isSummitIClassMinValid}
        />
      ) : (
        <DollarComponent
          dollarValue={dollarValue}
          readOnly
          onKeyDown={onKeyDown}
          handleChange={handleChange}
        />
      )}
      <style jsx>{styles}</style>
    </div>
  );
};

AllocationInput.defaultProps = {
  percentMode: true
};
export default AllocationInput;
